/**
 * Рынок Polymarket не на боевом /app: /tests, /russkie, их студии, /labs и @udmurte.
 *
 * Купон, драйвер и плитка читают один флаг. Иначе чужой профиль со
 * сохранённым «по рынку» открыл бы Market всем, кто крутил ручку, пока
 * она стояла на проде.
 */

import { useSession } from '../access/session';
import { feedKindOf, type FeedKind } from '../lib/feedContext';
import { LAB_BUNDLE, labsPath } from '../next/route';

export const POLY_MARKET_OWNER = 'udmurte';

export function polyMarketAllowed(opts?: {
  username?: string | null;
  pathname?: string;
  search?: string;
  feed?: FeedKind;
  labBundle?: boolean;
}): boolean {
  const path = opts?.pathname ?? (typeof location === 'undefined' ? '' : location.pathname);
  const search = opts?.search ?? (typeof location === 'undefined' ? '' : location.search);
  const lab = opts?.labBundle ?? LAB_BUNDLE;
  if (lab || labsPath(path)) return true;
  const feed = opts?.feed ?? feedKindOf({ pathname: path, search });
  if (feed === 'tests' || feed === 'ru') return true;
  const raw = opts && 'username' in opts ? opts.username : useSession.getState().me.username;
  const name = (raw ?? '').replace(/^@/, '').trim().toLowerCase();
  return name === POLY_MARKET_OWNER;
}
